<template>
  <v-main>
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="8" md="4">
          <v-card class="elevation-12">
            <v-toolbar color="primary" dark flat>
              <v-toolbar-title>Login</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              <v-form>
                <v-text-field
                  label="Username"
                  name="name"
                  prepend-icon="mdi-account"
                  type="text"
                  v-model="name"
                />

                <v-text-field
                  id="password"
                  label="Password"
                  name="password"
                  prepend-icon="mdi-lock"
                  type="password"
                  v-model="password"
                />
              </v-form>
              <v-alert dismissible border="bottom" v-if="error" type="error">{{
                error
              }}</v-alert>
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="primary" @click.prevent="login">Login</v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      name: "",
      password: "",
      error: null
    };
  },
  methods: {
    async login() {
      const { name, password } = this;
      this.error = null;
      try {
        let res = await fetch(`${process.env.VUE_APP_BACKEND}/users/login`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({ name: name, password: password })
        });
        if (res.ok) {
          res = await res.json();
          const token = res.token;
          const user = res.user;
          localStorage.setItem("user-token", token);
          localStorage.setItem("user", user);

          await this.$router.push("/");
        } else {
          res = await res.text();
          console.log(res);
          this.error = res;
        }
      } catch (e) {
        console.log("Error " + e.message);
      }
    }
  }
};
</script>

<style scoped></style>
